import { showErrorMessage } from '@/helpers';
import { FEATURE_NAMES, DATE_TYPES } from '@/utils/constants';
import { FeatureManager } from '@/directives';
import moment from 'moment';

export const RosteringMixin = {
    mixins: [FeatureManager],
    data() {
        return {
            availableTeamMemberIds: []
        };
    },
    computed: {
        $_availabilityIndicatorsEnabled() {
            return this.$_hasFeature(FEATURE_NAMES.TeamMemberRosterConfiguration);
        }
    },
    methods: {
        async $_getAvailableTeamMembers(date) {
            let appointmentDate = date;
            if (appointmentDate && typeof appointmentDate === 'object') {
                appointmentDate = moment(appointmentDate).format(DATE_TYPES.internationalDate); // YYYY-MM-DD
            }
            try {
                const response = await this.$store.dispatch('team/FETCH_AVAILABLE_TEAM_MEMBERS', {
                    appointmentDate
                });

                this.availableTeamMemberIds = response;
            } catch (e) {
                const message = 'Error in fetching available team members';
                this.availableTeamMemberIds = [];
                showErrorMessage(this, message, e);
            }
        },
        $_haveCommonAppointmentDate(selectedItems, itemList) {
            // Items can be stops or shipments
            if (!this.$_availabilityIndicatorsEnabled || !selectedItems?.length || !itemList?.length) 
                return false;

            const firstStopOrShipment = itemList.find((item) => (item.stopId ?? item.shipmentId) === selectedItems[0]);
            if (!firstStopOrShipment) 
                return false;

            const firstDate = firstStopOrShipment.tripDate;
            const sameDate = selectedItems.every((id) => {
                const stopOrShipment = itemList.find((item) => (item.stopId ?? item.shipmentId) === id);
                return (
                    stopOrShipment &&
                    ((!stopOrShipment.tripDate && !firstDate) ||
                        moment(firstDate).isSame(moment(stopOrShipment.tripDate), 'day'))
                );
            });

            return sameDate;
        },
        $_getCommonAppointmentDate(selectedItems, itemList) {
            // Items can be stops or shipments
            if (
                !this.$_haveCommonAppointmentDate(selectedItems, itemList) ||
                !selectedItems?.length ||
                !itemList?.length
            )
                return null;

            const firstStopOrShipment = itemList.find((item) => (item.stopId ?? item.shipmentId) === selectedItems[0]);
            return firstStopOrShipment?.tripDate;
        },
        $_validTripDateSelected(date) {
            if (!date) {
                // If no date is selected, we assume the date is today
                return true;
            }

            if (!['object', 'string'].includes(typeof date)) 
                return false;

            if (typeof date === 'object') {
                // date string format, e.g. 'Thu Mar 27 2025 11:00:51 GMT+0800 (Philippine Standard Time)'
                return moment(date, 'ddd MMM DD YYYY HH:mm:ss [GMT]Z').isSameOrAfter(moment(), 'day');
            }

            const appointmentDate = date && date.trim().length > 0 ? date : moment();
            return moment(appointmentDate).isSameOrAfter(moment(), 'day');
        },
        $_canDisplayAvailabilityIndicators(isEnabledByCaller, date) {
            return isEnabledByCaller && this.$_availabilityIndicatorsEnabled && this.$_validTripDateSelected(date);
        },
        $_canDisplayAvailabilityIndicatorsForBulkAction(selectedItems, itemList) {
            const appointmentDate = this.$_getCommonAppointmentDate(selectedItems, itemList);
            return (
                this.$_haveCommonAppointmentDate(selectedItems, itemList) &&
                this.$_canDisplayAvailabilityIndicators(true, appointmentDate)
            );
        }
    }
};
